export function hideExpandableMenu(){

    $(".smetio-app-ui-side-menu-hide-properties_"+this.id).attr("data-smetio-show", "no");
        
    $(".smetio-app-ui-side-menu-show-properties_"+this.id).attr("data-smetio-show", "yes");

    $("#"+this.id).css("width", this.arrowHolderWidth);

    $(".smetio-app-ui-side-menu-shrink-properties_"+this.id).attr("disabled", true);

};